import { IdIdentifier, TimeIdentifiers } from '../common/identifiers';
import { I18nEntry } from '../translation/translation';

export type Partner = IdIdentifier &
  TimeIdentifiers & {
    type: PartnerType;
    title: string;
    description: string;
    videoUrl: string;
    googleSheetId: string;
    enabled: boolean;
    i18n?: I18nEntry[];
  };

export enum PartnerType {
  Analysis = 'analysis',
  Journal = 'journal',
  Research = 'research',
}
